import React, { useState, useEffect, useContext } from "react";
import ToolTip from "react-portal-tooltip";
import ProfileHeader from "./ProfileHeader";
import Loading from "../Loading";
import Slider from "../Slider/Slider";
import AuthContext from "../../contexts/AuthContext";
import { FaEdit } from "react-icons/fa";

import styles from "./User.module.css";
import cogoToast from "cogo-toast";
import { A } from "hookrouter";
import api from "../../actions/common";

const User = ({ id }) => {
  const [tab, setTab] = useState(0);
  const tabProps = { tab, setTab };
  const { token } = React.useContext(AuthContext);
  const [loading, setLoading] = React.useState(false);
  const currentUserId = React.useContext(AuthContext).user._id;
  const [followers, setFollowers] = useState([]);
  const [followings, setFollowings] = useState([]);
  const [readingListCount, setReadingListCount] = useState(0);
  const [storiesCount, setStoriesCount] = useState(0);
  const userId = id || currentUserId;
  const [user, setUser] = useState({});
  console.log(user);

  const getFollowers = async (uid) => {
    if (uid === currentUserId) {
      const rawResponse = await fetch("https://api.yazbie.com/api/follow", {
        method: "GET",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: token,
        },
      });

      try {
        let content = await rawResponse.clone().json();
        console.log(content);
        if (content && content.success) {
          console.log(content);
          if (content && content.followers) {
            setFollowers(content.followers);
          } if (content && content.followings) {
            setFollowings(content.followings);
          }
        } else if (content && !content.success) {
          cogoToast.error(content.message);
        }
      } catch (err) {
        cogoToast.error(await rawResponse.clone().text());
      }
    }
  };

  const getBooksWrittenByUser = async (uid) => {
    if (uid !== currentUserId) {
      setStoriesCount(0);
      return;
    }
    const rawResponse = await fetch(
      `https://api.yazbie.com/api/stories/userStories?status=Published`,
      {
        method: "GET",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: token,
        },
      }
    );

    try {
      let content = await rawResponse.clone().json();

      if (content && content.success) {
        setStoriesCount(content.stories.length);
      } else if (content && !content.success) {
        cogoToast.error(content.message);
      }
    } catch (err) {
      cogoToast.error(await rawResponse.clone().text());
      return false;
    }
  };

  const getLibraryList = async (uid) => {
    if (uid !== currentUserId) {
      setReadingListCount(0);
      return;
    }
    const rawResponse = await fetch("https://api.yazbie.com/api/libraries", {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: token,
      },
    });
    try {
      let content = await rawResponse.clone().json();

      if (content && content.success) {
        setReadingListCount(content.libraries.length);
      } else if (content && !content.success) {
        cogoToast.error(content.message);
      }
    } catch (err) {
      cogoToast.error(await rawResponse.clone().text());
      return false;
    }
  };

  const getUser = async () => {
    const rawResponse = await fetch(
      `https://api.yazbie.com/api/users/${userId}`,
      {
        method: "GET",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: token,
        },
      }
    );
    console.log(rawResponse);
    try {
      let content = await rawResponse.clone().json();
      console.log(content);
      if (content && content.success) {
        console.log(content.user);
        setUser(content.user);
        if (content && content.followees) {
          console.log(content.followees);
          setFollowers(content.followees);
        } if (content && content.following) {
          setFollowings(content.following);
        }
        return content.user;
      } else if (content && !content.success) {
        cogoToast.error(content.message);
      }
    } catch (err) {
      cogoToast.error(await rawResponse.clone().text());
      return false;
    }
  };

  const loadData = async () => {
    setLoading(true);
    const u = await getUser();
    await Promise.all([
      getFollowers(u._id),
      getLibraryList(u._id),
      getBooksWrittenByUser(u.id),
    ]);

    setLoading(false);
  };

  useEffect(() => {
    loadData();
  }, [id]);

  if (loading) {
    return <Loading />;
  }
  return (
    <div className={styles.user}>
      <ProfileHeader
        user={user}
        followers={followers}
        readingListCount={readingListCount}
        storiesCount={storiesCount}
        loadData={loadData}
        updateFollowers={getUser}
      />
      <div className={styles.maincontainer}>
        <SideBar user={user} followers={followers} followings={followings} currentUserId={currentUserId} />
        <Main {...tabProps} currentUserId={currentUserId} user={user} />
      </div>
    </div>
  );
};

const SideBar = ({ user, followers, followings, currentUserId }) => {
  const [editBio, setEditBio] = useState(false);
  const [bio, setBio] = useState(user.bio);
  const { token } = useContext(AuthContext);
  const [loading, setLoading] = useState(false);
  const saveBio = () => {
    setEditBio(false);
    submitData();
  };

  const submitData = async (blob) => {
    var formdata = new FormData();
    formdata.append('bio', bio);

    const resp = await api.put('/users/updateProfile', token, formdata, setLoading);
    console.log(resp);

    if (resp.success || resp.status) {
      cogoToast.success("Successfully updated bio");
    } else {
      if (resp.message) {
        cogoToast.error(resp.message);
      } else {
        cogoToast.error("Something Went Wrong");
      }
    }
  };

  return (
    <div className={styles.sidebar}>
      <div>
        <span className={styles.label}>About</span>
        {!editBio && user._id === currentUserId && <span className={styles.editicon} onClick={() => setEditBio(true)}><FaEdit /></span>}
      </div>
      {editBio
        ?
        <div className={styles.body}>
          <textarea rows="6" cols="20" className={styles.bioInput} type="text" value={bio} onChange={(e) => setBio(e.target.value)}></textarea>
          <button className={styles.saveButton} onClick={saveBio}>Save</button>
        </div>
        :
        <div className={styles.body}>{bio}</div>
      }
      {followers.length > 0 && (
        <FollowList followings={followers} title={"Followers"} />
      )}

      {followings.length > 0 && (
        <FollowList followings={followings} title={"Following"} />
      )}
    </div>
  );
};

const FollowList = ({ followings, title }) => {
  console.log("FOLLWOERS: ");
  console.log(followings);
  return (
    <React.Fragment>
      <div className={styles.label}>{title}</div>
      <div className={styles.flatList}>
        {followings.slice(0, 5).map((following) => (
          <FollowListItem f={following} />
        ))}
      </div>
    </React.Fragment>
  );
};

const FollowListItem = ({ f }) => {
  console.log(f);
  const [tooltip, setTooltip] = React.useState(false);
  // const id = UUID();
  const follower = f.follower || f.followee || f;
  console.log(f);
  const ref = React.useRef();
  return (
    <React.Fragment>
      <ToolTip
        active={tooltip}
        parent={ref.current}
        position="right"
        arrow="center"
        tooltipTimeout={100}
      >
        {follower?.name}
      </ToolTip>
      <A href={`/user/${follower?.userId || follower?._id}`}>
        <div
          ref={ref}
          className={`${styles.item} ${styles.tooltip}`}
          onMouseEnter={() => setTooltip(true)}
          onMouseLeave={() => setTooltip(false)}
        >
          <div
            className={styles.avatar}
            style={{
              // backgroundImage: `url(${follower.avatar})`,
              backgroundImage: `url(${follower?.avatar_link ||
                "https://external-content.duckduckgo.com/iu/?u=https%3A%2F%2Fcdn.iconscout.com%2Ficon%2Ffree%2Fpng-256%2Favatar-369-456321.png&f=1&nofb=1"
                })`,
            }}
          />
        </div>
      </A>
    </React.Fragment>
  );
};

const Main = ({ user, currentUserId }) => {
  console.log(user, currentUserId);
  const [bookLists, setBookLists] = React.useState([]);
  const [tab, setTab] = React.useState("library");
  let libraries = [];
  const { token } = React.useContext(AuthContext);

  const getUserReadingList = () => {
    if (user._id !== currentUserId) {
      return;
    }
    (async () => {
      const rawResponse = await fetch(
        "https://api.yazbie.com/api/stories/userReading",
        {
          method: "GET",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: token,
          },
        }
      );
      try {
        let content = await rawResponse.clone().json();
        // console.log(content);
        if (content && content.success) {
          const readStories = [];
          content.readStories.forEach((story) => {
            readStories.push({
              ...story.storyRead,
              coverImageBackup: "/assets/images/Dashboard/book5.png",
            });
          });
          const readingStories = [];
          content.readingStories.forEach((story) => {
            readingStories.push({
              ...story.storyRead,
              coverImageBackup: "/assets/images/Dashboard/book5.png",
            });
          });
          const myReadingList = await getReadingList();
          // console.log(myReadingList);
          loadBooks({
            readStories: readStories,
            readingStories: readingStories,
            myReadingList: myReadingList,
          });
        } else if (content && !content.success) {
          cogoToast.error(content.message);
        }
      } catch (err) {
        // console.log(err);
        // console.log(await rawResponse.clone().text());
        cogoToast.error(await rawResponse.clone().text());
      }
    })();
  };

  const getLibraryList = async () => {
    if (user._id !== currentUserId) {
      return;
    }
    const rawResponse = await fetch("https://api.yazbie.com/api/libraries", {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: token,
      },
    });
    try {
      let content = await rawResponse.clone().json();
      // console.log(content);
      if (content && content.success) {
        return content;
      } else if (content && !content.success) {
        cogoToast.error(content.message);
      }
    } catch (err) {
      // console.log(err);
      // console.log(await rawResponse.clone().text());
      cogoToast.error(await rawResponse.clone().text());
      return false;
    }
  };

  const getReadingList = async () => {
    if (user._id !== currentUserId) {
      return;
    }
    libraries = await getLibraryList();
    let readingList = null;
    libraries.libraries.forEach((library) => {
      if (library.libName === "My Reading List") {
        readingList = library;
      }
    });
    if (readingList) {
      let stories = [];
      readingList.Stories.forEach((story) => {
        stories = [
          ...stories,
          { ...story, coverImageBackup: "/assets/images/Dashboard/book5.png" },
        ];
      });
      return stories;
    } else {
      return [];
    }
  };

  const loadBooks = (list) => {
    if (tab === "library") {
      const loadedBookLists = [
        {
          books: list.readingStories?.length === 0 ? [] : list.readingStories,
          title: "Continue Reading",
        },
        {
          books: list.myReadingList?.length === 0 ? [] : list.myReadingList,
          title: "My Library",
        },
        {
          books: list.readStories?.length === 0 ? [] : list.readStories,
          title: "Completed",
        },
      ].filter((b) => b.books.length > 0);

      setBookLists(loadedBookLists);
    } else if (tab === "reading_list") {
      // console.log(list.lists);
      const loadedBookList = list.lists.map((library) => {
        return {
          books: library.Stories.length === 0 ? [] : library.Stories,
          title: library.libName,
        };
      });
      setBookLists(loadedBookList);
    } else if (tab === "works") {
      const loadedBookLists = [
        {
          books: list.drafts?.length === 0 ? [] : list.drafts,
          title: "Drafts",
        },
        {
          books: list.published?.length === 0 ? [] : list.published,
          title: "Published Books",
        },
      ];
      // console.log("Loaded Books List: " + loadedBookLists);
      setBookLists(loadedBookLists);
    } else {
      setBookLists([]);
    }
  };

  const getBooksWrittenByUser = async (status) => {
    const rawResponse = await fetch(
      `https://api.yazbie.com/api/stories/userStories?status=${status}`,
      {
        method: "GET",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: token,
        },
      }
    );
    try {
      let content = await rawResponse.clone().json();
      // console.log(content);
      if (content && content.success) {
        return content.stories;
      } else if (content && !content.success) {
        cogoToast.error(content.message);
      }
    } catch (err) {
      cogoToast.error(await rawResponse.clone().text());
      return false;
    }
  };

  useEffect(() => {
    (async () => {
      if (tab === "library") {
        getUserReadingList();
      } else if (tab === "reading_list") {
        let libraries = await getLibraryList();
        libraries.libraries.forEach((library) => {
          library.Stories.map((story) => {
            story.coverImage = "/assets/images/Dashboard/book5.png";
            return story;
          });
        });
        loadBooks({ lists: libraries.libraries });
      } else if (tab === "works") {
        let draftBooks = await getBooksWrittenByUser("Draft");
        let publishedBooks = await getBooksWrittenByUser("Published");
        draftBooks = draftBooks.map((book) => {
          book.coverImage = "/assets/images/Dashboard/book5.png";
          return book;
        });
        publishedBooks = publishedBooks.map((book) => {
          book.coverImage = "/assets/images/Dashboard/book5.png";
          return book;
        });
        loadBooks({ drafts: draftBooks, published: publishedBooks });
      } else {
        setBookLists([]);
      }
    })();
  }, [tab]);

  return (
    <div className={styles.main}>
      <div className={styles.tabs}>
        {user._id === currentUserId && (
          <div
            className={`${styles.tab} ${tab === "library" ? styles.active : ""
              }`}
            onClick={() => setTab("library")}
          >
            Library
          </div>
        )}

        <div
          className={`${styles.tab} ${tab === "works" ? styles.active : ""}`}
          onClick={() => setTab("works")}
        >
          Works
        </div>
        {user._id === currentUserId && (
          <div
            className={`${styles.tab} ${tab === "reading_list" ? styles.active : ""
              }`}
            onClick={() => setTab("reading_list")}
          >
            Reading List
          </div>
        )}
      </div>
      <div className={styles.content}>
        <ReadingLists bookLists={bookLists} />
      </div>
    </div>
  );
};

const ReadingLists = ({ bookLists }) => {
  if (bookLists.length === 0) {
    return (
      <div className={styles.heading}>Books in Progress and books in My Library will appear here</div>
    );
  }

  return (
    <div>
      {bookLists.map((books) => (
        <ReadingList books={books.books} title={books.title} />
      ))}
    </div>
  );
};

const ReadingList = ({ books, title }) => (
  <React.Fragment>
    <div className={styles.heading}>{title}</div>
    <div className={styles.list}>
      <Slider data={books} myStory={true} />
    </div>
  </React.Fragment>
);

export default User;
